import { Api } from '@/common/utils';
import { TASK_MODULES } from '@/common/constants/constants';

const formatSections = (sections = []) => {
  const sectionsObject = sections.reduce((acc, item) => {
    const { section, type } = item;

    if (!acc[section]) {
      acc[section] = { task: {}, question: {} };
    }

    acc[section][type.toLowerCase()] = item;
    return acc;
  }, {});

  Object.keys(sectionsObject).forEach((module) => {
    const typeKey =
      module === TASK_MODULES.IMMEDIATE ||
      module === TASK_MODULES.MAIN ||
      module === TASK_MODULES.ASSET
        ? 'question'
        : 'task';

    sectionsObject[module].disabled =
      !sectionsObject?.[module]?.[typeKey]?.allowed;
  });

  return sectionsObject;
};

export const getDecedentList = async () => {
  const { data } = await Api.request({
    url: '/decedent/list',
  });

  return data.decedents;
};

export const getDecedent = async (decedentId) => {
  if (!decedentId) {
    return null;
  }

  const {
    data: { decedent, primaryUser, sections, showClosingCaution },
  } = await Api.request({
    url: `/decedent/${decedentId}`,
  });

  return {
    decedent: {
      ...decedent,
      showClosingCaution:
        typeof showClosingCaution === 'boolean'
          ? showClosingCaution
          : decedent?.showClosingCaution,
    },
    primaryUser: primaryUser?.user,
    role: primaryUser?.role,
    sections: formatSections(sections),
  };
};

export const addDecedent = async (payload) => {
  const {
    data: { decedent, primaryUser },
  } = await Api.request({
    method: 'post',
    url: '/decedent/create',
    payload,
  });

  return {
    ...decedent,
    primaryUser: primaryUser.user,
  };
};

export const editDecedent = async (id, form) => {
  const { data } = await Api.request({
    method: 'put',
    url: `/decedent/${id}`,
    payload: form,
  });

  return data;
};

export const editUserPersona = async (id, form) => {
  const { data } = await Api.request({
    method: 'put',
    url: `/user/${id}`,
    payload: form,
  });

  return data;
};

export const getTaskList = async (decedentId, module) => {
  const {
    data: { tasks },
  } = await Api.request({
    url: `/task/list?section=${module}&decedentId=${decedentId}`,
  });

  return tasks.map((value, ind) => ({ ...value, number: ind + 1 }));
};

export const submitQuestion = async (payload) => {
  await Api.request({
    url: '/question/submit',
    method: 'post',
    payload,
  });

  return payload;
};
